/**
 * Created by Jerker Nord on 2023-10-20.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Loner} from "../../../Loner";
import {gsap} from "gsap";
import {LonerSound} from "../../../sound/LonerSound";
import {LonerGameMode} from "../../../server/LonerGameMode";
import {MAIN_FG_ANIMATION_NAMES} from "../../general/LonerForegroundView";

export class LonerTickTickBoomIntroView extends PIXI.Container implements StageLayer {

    private _clickCallback:Function;

    constructor() {
        super();
        this.name = "LonerTickTickBoomIntroView";
        this.init();
    }

    private init():void {
        this.visible = false;
    }

    public restore():void {
        Loner.keypadPlugin.setWin(Loner.model.accumulatedRoundWin, false, Loner.isWinBelowStake());
    }

    private onButtonClick():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            Loner.foregroundView.endForegroundSwitchTL();
            Loner.foregroundView.clearAnimationTrack(0);
            this._clickCallback();
        });
        return tl;
    }

    public getShowTL(callback:Function):gsap.core.Timeline {
        Loner.xBetView.pauseRedDotBlinkTL();
        const showTL:gsap.core.Timeline = gsap.timeline();
        showTL.add(() => {
            this._clickCallback = callback;
            Loner.soundPlayer.fadeMusic(1, 0, 0.1);
            Loner.soundPlayer.stopSound(LonerSound.START_GAME);
            Loner.soundPlayer.fadeMusic(1, 0, 100);
            Loner.soundPlayer.playSound(LonerSound.TTB_INTRO_MUSIC, 1, 1000);
        });
        showTL.add(Loner.foregroundView.setMode(LonerGameMode.FEATURE_TICK_TICK_BOOM));
        showTL.add([
            () => {
                Loner.foregroundView.playTTBArmsAnimation(MAIN_FG_ANIMATION_NAMES.TTB_ARMS_START, false);
                Loner.allReelView.visible = false;
                Loner.allReelView.resetAllReels();
            }
        ], "-=2.1");
        showTL.add(this.onButtonClick());
        return showTL;
    }
}